import SvgIcon from "./SvgIcon";

export default function BlobIcon({
  startColor = "#FE00F2",
  stopColor = "#FFC371"
}) {
  let blobs = [
    "M443,301.5Q392,353,352,396.5Q312,440,254,428.5Q196,417,143,391.5Q90,366,77,308Q64,250,62,181Q60,112,126,91Q192,70,258.5,44.5Q325,19,366.5,77Q408,135,451,192.5Q494,250,443,301.5Z",
    "M423,320.5Q444,391,373.5,402.5Q303,414,251,411Q199,408,146.5,385.5Q94,363,57,306.5Q20,250,62.5,197Q105,144,152,119Q199,94,250.5,91.5Q302,89,353,113.5Q404,138,403,194Q402,250,423,320.5Z",
    "M404,297.5Q381,345,347.5,396.5Q314,448,248.5,452Q183,456,144,405.5Q105,355,85.5,302.5Q66,250,85,197Q104,144,148.5,109.5Q193,75,253,65Q313,55,367,90.5Q421,126,424,188Q427,250,404,297.5Z",
    "M455.5,321Q445,392,375,406.5Q305,421,252,414Q199,407,126,400Q53,393,60.5,321.5Q68,250,95,203.5Q122,157,157,114Q192,71,247.5,79Q303,87,344.5,119Q386,151,426,200.5Q466,250,455.5,321Z",
    "M442,301Q390,352,349,390Q308,428,243,449Q178,470,146.5,409Q115,348,68,299Q21,250,70,202.5Q119,155,158.5,122.5Q198,90,251.5,86Q305,82,343,118.5Q381,155,437.5,202.5Q494,250,442,301Z",
  ]
  let randBlob = [];
  for (let i = 0; i < 5; i++) {
    const idx = Math.floor(Math.random()*blobs.length);
    randBlob.push(blobs[idx]);
    blobs.splice(idx, 1);
  }
  randBlob.push(randBlob[0]);

  return (
    <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" width="100%" id="blobSvg">
      <defs>
        <linearGradient id={`gradient${startColor}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={startColor}/>
          <stop offset="100%" stopColor={stopColor}/>
        </linearGradient>
      </defs>
      <path fill={`url(#gradient${startColor})`}>
        <animate attributeName="d"
          dur="10000ms"
          repeatCount="indefinite"
          values={randBlob.join(";")}>
          {/* Add 1st and last value same for Loop animation */}
        </animate>
      </path>
    </svg>
  )
}
